import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BITCOIN_APP_CONFIG} from "../../config/api";
import {LoaderService} from "../loader.service";
import {BehaviorSubject, Observable} from "rxjs";
import {ExternalLinkEnum} from "../../shared/bitcoin-app/enums/external-link.enum";
import {isAndroid, isMobile} from 'mobile-device-detect';

@Injectable({
  providedIn: 'root'
})
export class BitcoinAppService {
  private config = BITCOIN_APP_CONFIG;

  iframeVisibility = new BehaviorSubject(null);
  updateBalance = new BehaviorSubject(null);

  method = {
    paypal: 'paypal',
    cashApp: 'cashApp'
  }

  constructor(private http: HttpClient,
              public loaderService: LoaderService) {
  }

  getCheckoutUrl(aiStyleId: string, amount: number, aiTypeImageGeneration: string, keywords: string): Observable<any> {
    this.loaderService.show();
    return this.http.post<any>(this.config.getCheckoutUrl, {aiStyleId, amount, aiTypeImageGeneration, keywords});
  }

  getWithdrawUrl(amount): Observable<any> {
    this.loaderService.show();
    return this.http.post<any>(this.config.getWithdrawUrl, {amount});
  }

  isWithdrawBitcoinSessionExist(): Observable<any> {
    this.loaderService.show();
    return this.http.post<any>(this.config.isWithdrawCryptoSessionExist, {});
  }

  isCryptoCheckoutSessionExist(shortName: string): Observable<any> {
    this.loaderService.show();
    return this.http.post<any>(this.config.isCheckoutCryptoSessionExist, {shortName});
  }

  getCryptoWithdrawUrl(amount, shortName: string): Observable<any> {
    this.loaderService.show();
    return this.http.post<any>(this.config.getCryptoWithdrawUrl, {amount, shortName});
  }

  isCryptoWithdrawSessionExist(shortName: string): Observable<any> {
    this.loaderService.show();
    return this.http.post<any>(this.config.isWithdrawCryptoSessionExist, {shortName});
  }

  cryptoGenerateImages(aiStyleId: string, aiTypeImageGeneration: string, keywords: string): Observable<any> {
    this.loaderService.show();
    return this.http.post<any>(this.config.cryptoGenerateImages, {aiStyleId, aiTypeImageGeneration, keywords});
  }

  hideIframe(): void {
    this.iframeVisibility.next({show: false, src: ''});
  }
  showIframe(src: string, shortName: string): void {
    this.iframeVisibility.next({show: true, src: src, shortName: shortName});
  }

  requestBalanceUpdating(): void {
    this.updateBalance.next(Math.random());
    this.updateBalance.next(null);
  }

  openCashAppUSDC() {
    this.checkAndOpenApp(this.method.cashApp, ExternalLinkEnum.cashAppWebUrl);
  }

  openPaypal() {
    this.checkAndOpenApp(this.method.paypal, ExternalLinkEnum.paypalWebUrl);
  }

  checkAndOpenApp(method: string, fallbackUrl: string) {
    const deepLink: string = this.getDeepLink(method);

    if (isMobile) {
      this.openUrl({url: deepLink});
    } else {
      window.open(fallbackUrl, '_system'); // Use _system for opening in external browser/store
    }
  }

  getDeepLink(method: string): string {
    if (method === this.method.paypal) {
      return isAndroid ? ExternalLinkEnum.paypalDeepLinkAndroid : ExternalLinkEnum.paypalDeepLink;
    } else if (method === this.method.cashApp) {
      return ExternalLinkEnum.cashAppDeepLink;
    }
  }

  openUrl(options) {
    window.open(options.url, '_blank');
    return true ;
  }
}
